import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppGlobals } from '@app/app.global';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private appGlobals: AppGlobals) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(
      request.clone({
        setHeaders: {
          'Accept-Language': localStorage.getItem('probankerCurrentLanguage')
            ? localStorage.getItem('probankerCurrentLanguage')
            : this.appGlobals.defaultLanguage + '-' + this.appGlobals.defaultLocale,
        },
      })
    );
  }
}
